<div class="generic-select-container">
  <label class="css-Etiqueta etiqueta" for="genericSelect">{{
    placeholder
    }}</label>
  <select id="genericSelect" [(ngModel)]="modelValue" (ngModelChange)="onInputChange($event)">
    <option *ngFor="let option of options" [value]="option.value">
      {{ option.label }}
    </option>
  </select>
</div>